import { render, staticRenderFns } from "./HouseholdSituations.vue?vue&type=template&id=3c3f1ef5&"
import script from "./HouseholdSituations.vue?vue&type=script&lang=js&"
export * from "./HouseholdSituations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports